/** Rendu complet des blocs signature Briouse — dispatch par block_type. */
import React, { Suspense, lazy } from "react";
import GoogleReviewsSection from "../GoogleReviewsSection";
import ContactFormBlock from "../cms/ContactFormBlock";
import FaqListBlock from "../cms/FaqListBlock";
import { absUrl, interpolate } from "./shared";
import { HeroBlock, StatsBandBlock, CtaFinalBlock } from "./HeroBlocks";
import {
  TitleBlock, TextBlock, ImageBlock, GalleryBlock, Columns2Block,
  CtaButtonBlock, SeparatorBlock, EditorialSectionBlock, AnchorNavBlock,
} from "./ContentBlocks";
import {
  OrientationCardsBlock, ComparisonTableBlock, TimelineBlock, PatrimonyCardsBlock,
  FeatureGridBlock, PricingTiersBlock, TestimonialsBlock, TestimonialsEditorialBlock, LancelotPromptBlock, FaqBlock,
} from "./CardBlocks";
import {
  AccommodationsGridBlock, AccommodationGridBlock, AccommodationTreeBlock,
  TourismGridBlock, PricingGridBlock, PartnersDirectoryBlock,
  EventsGridBlock, HorsesForSaleBlock, VenuesDirectoryBlock, AccommodationsDirectoryBlock,
} from "./DirectoryBlocks";
import { CarouselBlock, VadCardEmbedBlock, VadCatalogBlock } from "./VadBlocks";
import { ContributionFormBlock } from "./FormBlocks";

// Chargés à la demande : hors du bundle initial (perf premier chargement)
const CalendlySchedulerBlock = lazy(() => import("../cms/CalendlySchedulerBlock"));
const ContactTabsBlock = lazy(() => import("../cms/ContactTabsBlock"));
const CustomFormBlock = lazy(() => import("../cms/CustomFormBlock"));

export default function BlockRenderer({ block, vars = {}, pageId = null, unit = null, isFirstHero = true }) {
  if (block?.data?.hidden) return null;
  const d = block.data || {};
  const t = (s) => interpolate(s, vars, unit);
  const abs = absUrl;
  switch (block.block_type) {
    case "hero":
      return <HeroBlock d={d} t={t} abs={abs} isFirstHero={isFirstHero} />;
    case "stats_band":
      return <StatsBandBlock d={d} t={t} />;
    case "cta_final":
      return <CtaFinalBlock d={d} t={t} abs={abs} />;
    case "title":
      return <TitleBlock d={d} t={t} />;
    case "text":
      return <TextBlock d={d} t={t} />;
    case "image":
      return <ImageBlock d={d} abs={abs} />;
    case "gallery":
      return <GalleryBlock d={d} abs={abs} />;
    case "columns_2":
      return <Columns2Block d={d} t={t} abs={abs} />;
    case "cta_button":
      return <CtaButtonBlock d={d} />;
    case "separator":
      return <SeparatorBlock />;
    case "editorial_section":
      return <EditorialSectionBlock d={d} t={t} abs={abs} />;
    case "anchor_nav":
      return <AnchorNavBlock d={d} t={t} />;
    case "accommodations_grid":
      return <AccommodationsGridBlock data={d} />;
    case "orientation_cards":
      return <OrientationCardsBlock d={d} t={t} abs={abs} />;
    case "comparison_table":
      return <ComparisonTableBlock d={d} t={t} />;
    case "timeline":
      return <TimelineBlock d={d} t={t} />;
    case "patrimony_cards":
      return <PatrimonyCardsBlock d={d} t={t} abs={abs} />;
    case "feature_grid":
      return <FeatureGridBlock d={d} t={t} />;
    case "pricing_tiers":
      return <PricingTiersBlock d={d} t={t} />;
    case "testimonials":
      return <TestimonialsBlock d={d} t={t} abs={abs} />;
    case "testimonials_editorial":
      return <TestimonialsEditorialBlock d={d} t={t} />;
    case "google_reviews":
      return <GoogleReviewsSection title={t(d.title) || undefined} subtitle={t(d.subtitle) || ""} />;
    case "contribution_form":
      return <ContributionFormBlock data={d} vars={vars} />;
    case "lancelot_prompt":
      return <LancelotPromptBlock d={d} t={t} />;
    case "faq":
      return <FaqBlock d={d} />;
    case "accommodation_grid":
      return <AccommodationGridBlock limit={d.limit || 6} />;
    case "accommodation_tree":
      return <AccommodationTreeBlock buildingSlug={d.building_slug} />;
    case "tourism_grid":
      return <TourismGridBlock tag={d.tag} limit={d.limit} />;
    case "pricing_grid":
      return <PricingGridBlock entity_type={d.entity_type} entity_id={d.entity_id} title={d.title} />;
    case "contact_form":
      return <ContactFormBlock d={d} vars={vars} />;
    case "calendly_scheduler":
      return <Suspense fallback={null}><CalendlySchedulerBlock d={d} /></Suspense>;
    case "contact_tabs":
      return <Suspense fallback={null}><ContactTabsBlock d={d} vars={vars} /></Suspense>;
    case "custom_form":
      return <Suspense fallback={null}><CustomFormBlock d={d} /></Suspense>;
    case "faq_list":
      return <FaqListBlock d={d} pageId={pageId} />;
    case "partners_directory":
      return <PartnersDirectoryBlock context={d.context || "mariages"} />;
    case "horses_for_sale":
      return <HorsesForSaleBlock />;
    case "events_grid":
      return <EventsGridBlock d={d} />;
    case "carousel":
      return <CarouselBlock d={d} />;
    case "vad_card_embed":
      return <VadCardEmbedBlock qrToken={d.qr_token} />;
    case "vad_catalog":
      return <VadCatalogBlock />;
    case "venues_directory":
      return <VenuesDirectoryBlock context={d.context || "mariages"} basePath={d.base_path || null} />;
    case "accommodations_directory":
      return <AccommodationsDirectoryBlock context={d.context || "mariages"} basePath={d.base_path || null} />;
    default:
      return null;
  }
}
